import * as React from "react";
const SvgConnectorPending = (props) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", overflow: "visible", style: {
  display: "block"
}, width: 1.5, height: 40, viewBox: "0 0 1.5 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Vector 20", d: "M0.75 0V40", stroke: "#494949", strokeWidth: 1.5, strokeDasharray: "2 2" }));
export default SvgConnectorPending;
